import { Link } from "react-router-dom";
import { TRAVELLERS } from "../../data/content";

export const Travellers = () => {
    return (
        <section
            id="travellers"
            data-testid="travellers-section"
            className="relative bg-forest text-paper py-28 md:py-40 overflow-hidden"
        >
            <div className="mx-auto max-w-[1400px] px-6 md:px-10 lg:px-14">
                <div className="grid grid-cols-12 gap-6 mb-20">
                    <div className="col-span-12 md:col-span-8 reveal">
                        <p className="text-xs uppercase tracking-[0.28em] text-marigold mb-6">
                            — What kind of traveller are you, today?
                        </p>
                        <h2 className="font-serif text-paper text-4xl md:text-6xl lg:text-7xl leading-[1.05] tracking-tight font-light">
                            Often the same person,
                            <br />
                            <em className="italic text-marigold">at four different ages.</em>
                        </h2>
                        <p className="mt-8 text-paper/70 max-w-xl text-base md:text-[17px] leading-relaxed">
                            Pick the one that feels true this morning. We'll show you the journeys
                            we've curated for that mood, that pace, that kind of silence.
                        </p>
                    </div>
                </div>

                <div className="grid md:grid-cols-2 gap-x-14 gap-y-16">
                    {TRAVELLERS.map((t, i) => (
                        <Link
                            key={t.id}
                            to={`/journeys?traveller=${t.id}`}
                            data-testid={`traveller-${t.id}`}
                            className="reveal block group border-t border-paper/15 pt-8 transition-colors hover:border-marigold"
                            style={{ transitionDelay: `${i * 90}ms` }}
                        >
                            <div className="flex items-baseline gap-6">
                                <span className="font-serif italic text-marigold text-3xl md:text-4xl">
                                    {t.number}
                                </span>
                                <h3 className="font-serif text-paper text-3xl md:text-4xl leading-tight font-light group-hover:text-marigold transition-colors">
                                    {t.title}
                                </h3>
                            </div>
                            <p className="mt-4 font-serif italic text-marigold text-xl md:text-2xl leading-snug">
                                {t.line}
                            </p>
                            <p className="mt-5 text-paper/75 text-[15px] md:text-base leading-relaxed max-w-lg">
                                {t.body}
                            </p>
                            <span className="mt-8 inline-flex items-center gap-3 text-[11px] uppercase tracking-[0.22em] text-marigold border-b border-marigold/40 pb-1 group-hover:border-marigold transition-colors">
                                Begin this journey <span aria-hidden>→</span>
                            </span>
                        </Link>
                    ))}
                </div>
            </div>
        </section>
    );
};
